export default __webpack_public_path__ + "static/media/akasa-preloader.12019035.gif";